import type { IPSubnetInputValueOrDraft } from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import type { DiscoverySeedCommandFactory } from 'components/DiscoverySeed/model/DiscoverySeedModel';

type SetDiscoverySeedsCommand = {
  data: {
    seedList?: IPSubnetInputValueOrDraft;
    discoveryHistorySeeds?: {
      afterDate: string | null;
      daysLimit: number | null;
      enabled: boolean;
    };
    initialDiscoveryHistorySeeds?: {
      afterDate: string | null;
      daysLimit: number | null;
      enabled: boolean;
    };
    initialSeedList?: IPSubnetInputValueOrDraft;
  };
};

export const setDiscoverySeed: DiscoverySeedCommandFactory<
  SetDiscoverySeedsCommand
> = (cmdContext) => async (command) => {
  cmdContext.updateState((draft) => {
    draft.seedList = command.data.seedList ?? draft.seedList;
    draft.initialSeedList =
      command.data.initialSeedList ?? draft.initialSeedList;

    draft.discoveryHistorySeeds =
      command.data.discoveryHistorySeeds ?? draft.discoveryHistorySeeds;
    draft.initialDiscoveryHistorySeeds =
      command.data.initialDiscoveryHistorySeeds ??
      draft.initialDiscoveryHistorySeeds;
  });
};
